{
  "labels": {
    "language": "Language",
    "search": "search",
    "share": "Share",
    "sharing": "Sharing",
    "duplicate": "Duplicate",
    "export": "Export",
    "refresh": "Refresh",
    "delete": "Delete",
    "release": "Release",
    "cancel": "Cancel",
    "ok": "OK",
    "create-mashup": "Create mashup",
    "create": "Create",
    "create-version": "Create version",
    "release-version": "Release version",
    "version": "Version",
    "configure": "Configure",
    "released": "Released",
    "add-users-to-collaborate": "Add users to collaborate",
    "share-to-collaborate": "Share to collaborate",
    "delete-mashup-snackbar-text": "Mashup has been successfully deleted",
    "delete-version-snackbar-text": "Version has been successfully deleted",
    "update-mashup-snackbar-text": "Mashup has been successfully updated",
    "release-version-snackbar-text": "You have released a new version",
    "search-user": "Search user...",
    "no-shared": "No shared users.",
    "share-limitation": "Share with limitation",
    "view-only-mode": "Choose who else can access in view-only mode",
    "rename-mashup": "Rename your mashup",
    "mashup-tags": "Insert some mashup tags",
    "mashup-versions": "Mashup versions",
    "datamodel-hint": "Select a SMART Datamodel produced by this project",
    "no-flows": "There are no flows available for this Mashup",
    "editor": "editor",
    "owner": "owner",
    "no-one": "No one",
    "all-members": "All members of the organization",
    "everyone": "Everyone",
    "no-data-available": "No data available",
    "from": "From",
    "flow": "Flow",
    "save": "Save",
    "name": "Name",
    "open": "Open",
    "close": "Close",
    "login": "Login",
    "mashups": "Mashups",
    "share-confirmation": "Share confirmation",
    "confirm": "Confirm",
    "datasources": "Datasources",
    "custom-operators": "Custom operators",
    "mashup": "Mashup",
    "unshare-confirmation": "Unshare confirmation",
    "check-all": "Select all",
    "uncheck-all": "Unselect all"
  },
  "strings": {
    "create-new-version": "Create new version",
    "create-version-hint": "Write a new name for your version",
    "create-version-from-hint": "Select an existing version to start a new one from it",
    "create-version-mashup-text": "Version has been successfully created",
    "overlay-text": "You will have a better experience using this application in landscape mode.",
    "duplicate-mashup-text": "Mashup has been successfully duplicated",
    "create-version-mashup-tooltip": "Create a new mashup version",
    "delete-mashup-tooltip": "Only the owner can delete this mashup",
    "unshare-user-tooltip": "Only the owner of the mashup can unshare with a user",
    "release-version-tooltip": "This version has been released and can no longer be edited",
    "release-version-button-tooltip": "Create a new release for this mashup",
    "delete-mashup-question": "Are you sure you want to delete this mashup? | Are you sure you want to delete these mashups?",
    "delete-version-question": "Are you sure you want to delete this version?",
    "delete-mashup-shared-question": "This mashup is shared. Are you sure you want to delete it?",
    "release-version": "Are you sure you want to release version",
    "release-version-text": "After the release, this version cannot be changed anymore.",
    "release-version-text-warning": "<b>Warning</b>: If this mashup contains nested mashups, they will be released automatically.",
    "duplicate-mashup-question": "Which version do you want to duplicate?",
    "export-mashup-question": "Which version do you want to export?",
    "mashup-project-name": "Write a name for your mashup project",
    "json-schema-hint": "Put here the expected JSON schema and your mashup output will be validated against it",
    "resolve-mashup-issues": "You must first resolve mashup issues...",
    "share-dependencies-intro": "If you confirm the share, the following dependencies will also be shared automatically:",
    "confirm-share-dependencies-message": "Do you also want to share them with this user?",
    "confirm-unshare-dependencies-message": "Do you also want to unshare them with this user?",
    "duplicate-mashup-tooltip": "Only the owner can duplicate the mashup",
    "export-mashup-tooltip": "Only the owner can export the mashup",
    "unshare-dependencies-intro": "If you confirm the unshare, the selected dependencies will also be unshared automatically:"
  },
  "errors": {
    "version-name-required": "A name for your version of mashup is required"
  }
}
